import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignalWithTransform,
  Signal,
  ViewEncapsulation
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';

import { BooleanInputType } from '../core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[tiime-button], a[tiime-button]',
  templateUrl: './button.component.html',
  styleUrls: ['button.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.primary]': 'primary()',
    '[class.warn]': 'warn()',
    '[class.accent]': 'accent()',
    '[class.neutral]': 'neutral()',
    '[class.inverted]': 'inverted()',
    '[class.flat]': 'flat()',
    '[class.xxsmall]': 'xxsmall()',
    '[class.xsmall]': 'xsmall()',
    '[class.small]': 'small()',
    '[class.big]': 'big()',
    '[class.icon]': 'icon()',
    '[class.contrast]': 'contrast()',
    '[class.light]': 'light()',
    '[class.normal]': 'normal()'
    /* eslint-enable @typescript-eslint/naming-convention */
  },
  standalone: false
})
export class ButtonComponent {
  readonly primary: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly warn: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly accent: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly neutral: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly inverted: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly flat: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly xxsmall: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly xsmall: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly small: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly big: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly icon: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly contrast: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly showLoader = input(false);
  readonly loaderColor = input<ThemePalette | 'white'>('white');

  readonly light: Signal<boolean> = computed(() => !this.contrast());
  readonly normal: Signal<boolean> = computed(() => !this.inverted() && !this.flat());
}
